import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
// Reuse the existing conversations response shape so FactCheckingModal works unchanged.
import { ConversationsResponseSchema } from '../llm-usages/llm-usages.contract';
import {
  ConversationThreadParamsSchema,
  ConversationThreadResponseSchema,
  HotTopicConversationSummariesResponseSchema,
  HotTopicConversationsQuerySchema,
  HotTopicsOverviewResponseSchema,
  SetConversationHotTopicBodySchema,
  SetConversationHotTopicParamsSchema,
} from './train-ai.schema';

export const trainAIContract = createRESTContract({
  getHotTopicsOverview: {
    path: '/train-ai/hot-topics-overview',
    method: 'GET',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_VIEW],
    body: z.undefined(),
    response: HotTopicsOverviewResponseSchema,
  },
  getHotTopicConversations: {
    path: '/train-ai/hot-topic-conversations',
    method: 'GET',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_CHECKLIST],
    body: z.undefined(),
    query: HotTopicConversationsQuerySchema,
    response: ConversationsResponseSchema,
  },
  // Lightweight variant — returns only { _id, question, answer } per result.
  // Used for the hot-topic label click in FactCheckingModal where the full
  // conversation shape is not needed and would waste bandwidth.
  getHotTopicConversationSummaries: {
    path: '/train-ai/hot-topic-conversation-summaries',
    method: 'GET',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_CHECKLIST],
    body: z.undefined(),
    query: HotTopicConversationsQuerySchema,
    response: HotTopicConversationSummariesResponseSchema,
  },
  setConversationHotTopic: {
    path: '/train-ai/conversations/:conversationId/hot-topic',
    method: 'PATCH',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_CHECKLIST],
    body: SetConversationHotTopicBodySchema,
    params: SetConversationHotTopicParamsSchema,
    response: z.void(),
  },
  // Every question/answer turn of the conversation the given llm_usage belongs to,
  // so a reviewer can judge a single question in its context.
  getConversationThread: {
    path: '/train-ai/conversations/:conversationId/thread',
    method: 'GET',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_CHECKLIST],
    body: z.undefined(),
    params: ConversationThreadParamsSchema,
    response: ConversationThreadResponseSchema,
  },
});
